export default __webpack_public_path__ + "static/media/more-vertical.55ed89cb.svg";